import React, { useRef } from 'react'
import { StyledImageOverlay } from './imageOverlay.style';
import Backdrop from '@mui/material/Backdrop';
import CloseIcon from '@mui/icons-material/Close';

export interface IImageOverlayProps {
  isOpen: boolean;
  dismissable: boolean;
  imageSrc: string;
  imageAlt: string;
  imageStyle: any;
  handleClose: () => void;
}

const ImageOverlay: React.FC<IImageOverlayProps> = (props) => {

  const { isOpen, dismissable, imageSrc, imageAlt, imageStyle, handleClose } = props;

  const ref = useRef(null);

  // handle click outside of the image
  const handleClickBackdrop = (event: any) => {
    if (!dismissable) {
      return;
    }
    const { current } = ref as any;
    if (current && !current.contains(event.target)) {
      handleClose();
    }
  };

  return (
    <StyledImageOverlay>
      <Backdrop
        className="image-overlay_backdrop"
        open={isOpen}
        onClick={handleClickBackdrop}
      >
      {isOpen && 
        <div className='overlay_container'>
          <button className='overlay__close-btn' onClick={handleClose} aria-label="close overlay button">
            <CloseIcon fontSize='large'></CloseIcon>
          </button>
          <img ref={ref} src={imageSrc} style={imageStyle} alt={imageAlt} className="overlay_image" title={imageAlt} />
        </div>}
      </Backdrop>
    </StyledImageOverlay>
  )
}

export const defaultProps = {
  isOpen: true,
  dismissable: true,
  imageSrc: 'https://i.imgur.com/skoRJ9P.png',
  imageAlt: 'Chat Image Overlay',
  imageStyle: {},
  handleClose: () => { },
}

ImageOverlay.defaultProps = defaultProps

export default ImageOverlay;
